import React from "react";

import Root from "components/root";

export default () => <Root />;
